import { render, staticRenderFns } from "./patientQuestionnaireResult.vue?vue&type=template&id=77c56568&scoped=true&"
import script from "./patientQuestionnaireResult.vue?vue&type=script&lang=js&"
export * from "./patientQuestionnaireResult.vue?vue&type=script&lang=js&"
import style0 from "./patientQuestionnaireResult.vue?vue&type=style&index=0&id=77c56568&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c56568",
  null
  
)

component.options.__file = "patientQuestionnaireResult.vue"
export default component.exports